import { useMemo } from 'react'

import { useQuery } from '@apollo/client'
import { uniqBy } from 'lodash'

import { Buyer, Order } from 'types'
import { relayConnectionToArray } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'

import { ORDER_CONTACTS } from './ordersShareModal.queries'
import { mockedMultipleOrderContactsDataResponse } from './test/orderContactsData.mock'
import { buyerDataToBuyerId } from 'features/Orders/Review/utils/review.utils'

type OrderContactsData = {
  buyers: Buyer[]
}

type ShareModalOrder = Pick<Order, 'id' | 'referenceNumber' | 'buyer'>

type useOrderContactsDataReturnType = OrderContactsData & {
  loading: boolean
}

export const useOrderContactsData = (
  orderIds: string[],
): useOrderContactsDataReturnType => {
  const { loading, data } = useQuery(ORDER_CONTACTS, {
    client: atlasClient,
    variables: { orderIds },
    skip: !orderIds || !orderIds.length,
  })

  const { buyers }: OrderContactsData = useMemo(() => {
    const myOrdersData =
      data?.orders || mockedMultipleOrderContactsDataResponse.data.orders
    const orders: ShareModalOrder[] = relayConnectionToArray(myOrdersData)
    return {
      buyers: uniqBy(orders, ({ buyer }) =>
        buyerDataToBuyerId({ name: buyer.name, email: buyer.email }),
      ).map(({ buyer }) => buyer),
    }
  }, [data])

  return {
    loading,
    buyers,
  }
}
